import React from 'react'
import { InvestorSummary } from '../../../types'
import { CardTitle } from '../../atoms/CardTitle'
import { css } from '@emotion/react'
import { Card, mq, Divider, colors } from 'plume-ui'
import { DescriptionList } from '../../atoms/DescriptionList'
import { A } from '../../atoms/A'
import { formatDate } from '@/lib/date'
import { SNSLinks } from '../../atoms/SNSLinks'
import { DoubleColumnContent } from './DoubleColumnContent'
import { useUser } from '@/contexts/AuthContext'
import { isGuest } from '@/lib/user'

type Props = {
  summary: InvestorSummary
}

export const InvestorBasicInfo: React.FC<Props> = (props) => {
  const user = useUser()
  return (
    <>
      <CardTitle>企業概要</CardTitle>
      <Card>
        <DoubleColumnContent>
          <DescriptionList
            list={{
              企業名: { text: props.summary.name },
              英語名: { text: props.summary.englishName },
              代表者名: { text: props.summary.representative },
              住所: { text: props.summary.address },
              電話番号: {
                text: props.summary.telephone,
                isHidden: isGuest(user),
                extraClassName: 'phone',
              },
              設立: {
                text:
                  props.summary.established &&
                  formatDate(props.summary.established, 'yyyy/MM'),
              },
            }}
          />
          <Divider
            dashed
            css={css`
              width: 100%;
              margin: 0.5rem 0;

              ${mq.large} {
                display: none;
              }
            `}
          />
          <DescriptionList
            list={{
              種別: {
                text: props.summary.category,
                help: '投資家の種別 (VC、海外VC、事業法人、金融機関など)',
              },
              属性: { text: props.summary.subCategory },
              旧または別名: { text: props.summary.formerName },
              URL: {
                text: (
                  <A href={props.summary.website} target="_blank">
                    {props.summary.website}
                  </A>
                ),
              },
              SNS: {
                text: (
                  <>
                    <SNSLinks
                      facebook={props.summary.facebook}
                      twitter={props.summary.twitter}
                      color={colors.black10}
                      iconSize={20}
                      css={css`
                        ${mq.untilMedium} {
                          display: none;
                        }
                      `}
                    />
                    <SNSLinks
                      facebook={props.summary.facebook}
                      twitter={props.summary.twitter}
                      color={colors.black10}
                      iconSize={20}
                      css={css`
                        ${mq.large} {
                          display: none;
                        }
                      `}
                    />
                  </>
                ),
              },
            }}
          />
        </DoubleColumnContent>
      </Card>
    </>
  )
}
